import { createAction } from "@reduxjs/toolkit";

export const revertAll = createAction("global/revertAll");